import { render, staticRenderFns } from "./ProgressList.vue?vue&type=template&id=6d81641c&scoped=true&"
import script from "./ProgressList.vue?vue&type=script&lang=js&"
export * from "./ProgressList.vue?vue&type=script&lang=js&"
import style0 from "./ProgressList.vue?vue&type=style&index=0&id=6d81641c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d81641c",
  null
  
)

export default component.exports